/* TODO: t() */
import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import { getFirstPath } from './helpers';
import { RouteDescriptor } from './types';
import { LegacyContentContainer } from './LegacyContentContainer';

import NotFoundPage from '../Pages/NotFoundPage';

type RouterProps = {
  routes: ReadonlyArray<RouteDescriptor>;
};

export function Router(props: RouterProps) {
  let { routes } = props;
  let defaultRoutePath = getFirstPath(routes) ?? '';
  return (
    <Switch>
      {renderRoutes(routes)}
      {/* If none of the routes has handled "/" then redirect to default path */}
      <Route exact path="/">
        <Redirect to={defaultRoutePath} />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  );
}

function renderRoutes(
  routes: ReadonlyArray<RouteDescriptor>,
  keyPrefix = '',
): Array<JSX.Element> {
  return routes.flatMap((route, i) => {
    if (route.type === 'parent') {
      return renderRoutes(route.routes, keyPrefix + String(i) + '-');
    } else {
      let { path, component: Component, props: componentProps } = route;
      return [
        <Route
          key={keyPrefix + String(i)}
          exact
          path={path}
          render={(context) => {
            let element = <Component {...componentProps} {...context} />;
            return route.options?.legacyLayout ? (
              <LegacyContentContainer>{element}</LegacyContentContainer>
            ) : (
              element
            );
          }}
        />,
      ];
    }
  });
}
